import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { normalizeShiftConfig, type ShiftFrame } from '@/utils/shiftConfig';

export const useShiftConfig = () => {
  const { organizationId } = useAuth();

  return useQuery({
    queryKey: ['shift-config', organizationId],
    enabled: !!organizationId,
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('organizations')
        .select('id, shift_config')
        .eq('id', organizationId)
        .maybeSingle();
      if (error) throw error;
      return normalizeShiftConfig(data?.shift_config);
    },
  });
};

export const useUpdateShiftConfig = () => {
  const qc = useQueryClient();
  const { organizationId } = useAuth();

  return useMutation({
    mutationFn: async (shifts: ShiftFrame[]) => {
      if (!organizationId) throw new Error('Organization not found');
      const { error } = await (supabase as any)
        .from('organizations')
        .update({ shift_config: shifts })
        .eq('id', organizationId);
      if (error) throw error;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['shift-config', organizationId] });
      qc.invalidateQueries({ queryKey: ['organization', organizationId] });
    },
  });
};